<template>
  <el-dialog :title="$t('BusinessPurchaseComponentsExcel.title')" :visible.sync="dialogVisible" width="600px" :before-close="hide" destroy-on-close>
    <el-form ref="form" :model="form" :rules="rules" label-position="left">
      <el-form-item :label="$t('BusinessImportHistory.page.templateName')" prop="code">
        <BjSelectLov v-model="form.code" :option-list="CURRENCY_LIST" @change="onChange" />
      </el-form-item>
    </el-form>

    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" :disabled="!form.code" @click="onDownload">{{
        $t('ExcelConfig.Download')
      }}</el-button><br />
      2.{{ $t('ExcelConfig.MustHave') }}<br />
      3.{{ $t('ExcelConfig.MustBe') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile ref="BjImportFile" accept=".csv,.xlsx" :limit-size="128 * 1024" auto-upload @importFile="importStart">
        <template #top> </template>
        <template slot="default"> {{ $t('BusinessPurchaseComponentsExcel.uploadSize') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" :disabled="!form.code || !file" @click="confirm">{{
        $t('BusinessPurchaseComponentsExcel.import')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { baseDataApi, importApi, commonApi, thirdApi, settingApi } from '@/api';
import { downloadBlob } from '@/utils/index';
import { CSG_ORDER_SHIPPING_METHODS_LIST } from '@/utils/constants';
import { getShippingList } from '@/utils/index';

export default {
  data() {
    return {
      dialogVisible: false,
      file: null,
      form: {
        code: null,
      },
      rules: {
        code: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      CURRENCY_LIST: [],
      templateName: '',
      excelData: [],
      excelData2: [],
      CSG_ORDER_SHIPPING_METHODS_LIST,
      isableShipping: []
    };
  },
  mounted() {
    this.getLovHeadersByLovCodeAndName();
    getShippingList(this.$store.getters.cusId).then(res=>{
      this.isableShipping = res.filter(item=> !item.isDisable).map(item=> item.label)
    })
  },
  methods: {
    async getLovHeadersByLovCodeAndName() {
      let lovCode = null;
      const meaning = this.$store.getters.tenantNum;
      const res1 = await baseDataApi.getLovHeadersByLovCode({ lovCode: 'THID.THIRD_IMPORT_MODE_TENANT'});
      const lovId = res1.lovId;
      const queryPrams = {
        lovCode: 'THID.THIRD_IMPORT_MODE_TENANT',
        lovId,
        meaning
      };
      const res2 = await baseDataApi.getLovValuesByLovId(queryPrams);
      if (!res2.content?.length) return;
      lovCode = res2.content[0].value;

      const res3 = await baseDataApi.getLovHeadersByLovCode({ lovCode });
      if (res3.lovId) {
        this.getCurrencyList(res3.lovId);
      }
    },
    async getCurrencyList(id) {
      const res = await baseDataApi.getLovValuesByLovId({ lovId: id, size: 999 });
      this.CURRENCY_LIST = res.content.map(item => {
        return {
          label: item.meaning,
          value: item.value,
        };
      });
    },
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      // const data = { templateCode: this.form.code, tenantId: 0 }; 
      // importApi['exportExcelImportTemplateHeaders'](data).then(res => {
      //   downloadBlob(res, `${this.templateName}.xlsx`);
      // });
      importApi.getImportTemplateHeaders({
        templateCode: this.form.code,
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi.downloadFileByUrl({
          bucketName: 'test',
          url: res.content[0].templateUrl,
        }).then(resp => {
          downloadBlob(resp, `${this.templateName}.xlsx` );
        });
      });
    },
    // 判断文件是否有公式
    importStart(file) {
      // 判断是否是csv、xlsx
      const fileType = file.name.split('.').pop().toLowerCase();
      console.log(fileType,'fileType');
      if(fileType != 'csv' && fileType != 'xlsx' ) return this.$message.error(this.$t('formatErrorText'));
      // 导入操作
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const XLSX = require('xlsx');
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        let canDo = true
        // 遍历所有单元格
        Object.keys(worksheet).forEach(cellAddress => {
          if (cellAddress.startsWith('!')) return; // 跳过非单元格属性（如 !ref）
          const cell = worksheet[cellAddress];
          // 判断是否是公式
          if (cell.f){
            canDo = false
            this.$message.error(` ${cellAddress} ${this.$t('goodsPage.ps13')}`); return
          }
        });

        if(canDo){
          console.log(file,'file');
          this.sureImport = false
          this.importFile(file)
        }else{
          this.sureImport = true
        }
      };
      reader.readAsArrayBuffer(file);
    },
    importFile(file) {
      this.file = file;
      this.readExcel(file);
    },
    readExcel(file) {
      // 表格导入
      this.excelData = [];
      this.excelData2 = [];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const buffer = reader.result;
        const bytes = new Uint8Array(buffer);
        const length = bytes.byteLength;
        let binary = '';
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        const XLSX = require('xlsx');
        const wb = XLSX.read(binary, {
          type: 'binary',
        });
        this.excelData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1 });
        this.excelData2 = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
      };
    },
    beforeConfirm() {
      return new Promise((reslove, reject) => {
        // const obj = {};
        importApi
          .getImportTemplateHeaders({
            templateCode: this.form.code,
            size: 1,
            page: 0,
            total: 1,
            pageSize: 1,
            currentPage: 0,
          })
          .then(res => {
            // 获取模板失败
            if (res.content.length === 0) {
              this.$message({
                message: this.$t('ExcelConfig.failedTemplate'),
                type: 'error',
                duration: 5000,
              });
            } else {
              importApi
                .getDetailImportTemplateHeaders({ templateId: res.content[0].id })
                .then(resp => {
                  importApi
                    .getTemplateLines({
                      targetId: resp.templateTargetList[0].id,
                      size: 999,
                      page: 0,
                      total: 15,
                      pagesize: 999,
                      currentPage: 0,
                    })
                    .then(respp => {
                      reslove(respp.content);
                    });
                });
            }
          });
      });
    },
    confirm() {
      let bstop = true;
      let errorMsg = '';
      // if (this.excelData2.length > 200) return this.$message.warning(this.$t('ExcelConfig.excelNumberLimit'));

      const newArr = [];
      const duplicates = new Map();
      const newArr2 = [];
      this.beforeConfirm().then(apiList => {
        apiList.forEach(item => {
          this.excelData[0].forEach((kitem, kindex) => {
            if (kitem == item.columnName) {
              if (item.columnIndex != kindex) {
                bstop = false;
                errorMsg = `${item.columnName} ${this.$t('ExcelConfig.numberError')}`;
              }
            } else {
              if (item.columnIndex == kindex) {
                bstop = false;
                errorMsg = `${kitem} ${this.$t('ExcelConfig.nameError')}`;
              }
            }
          });
          if (bstop) {
            this.excelData2.forEach((jitem, jindex) => {
              if (jitem[item.columnName]) {
                if (newArr[jindex]) {
                  newArr[jindex][item.columnCode] = jitem[item.columnName];
                } else {
                  newArr[jindex] = {};
                  newArr[jindex][item.columnCode] = jitem[item.columnName];
                }
              }
              if (jitem.shipping_method && !CSG_ORDER_SHIPPING_METHODS_LIST.some(item => item.label.toUpperCase() == jitem.shipping_method.toUpperCase())) {
                bstop = false;
                errorMsg = `shipping_method is error`;
              }

              if (item.enabledFlag) {
                if (
                  item.columnType == 'Long' &&
                  isNaN(jitem[item.columnName]) &&
                  jitem[item.columnName] >= 0
                ) {
                  // 判断是不是整数
                  bstop = false;
                  errorMsg = `${item.columnName} ${this.$t('ExcelConfig.integerTip')}`;
                }
                if (
                  item.columnType == 'Decimal' &&
                  isNaN(jitem[item.columnName]) &&
                  jitem[item.columnName] >= 0
                ) {
                  // 判断是不是浮点数
                  bstop = false;
                  errorMsg = `${item.columnName} ${this.$t('ExcelConfig.numberTip')}`;
                }
                if(!jitem['quantity']){
                  bstop = false;
                  errorMsg = `quantity ${this.$t('emptyWarningText1')}`;
                }
                if (/^(?:[0-9]\d*)$/.test(jitem['quantity']) == false) {
                  bstop = false;
                  errorMsg =`quantity ${this.$t('formatErrorText')}`;
                }
                if (!item.nullableFlag && !jitem[item.columnName]) {
                  bstop = false;
                  errorMsg = `${item.columnName} ${this.$t('ExcelConfig.emptyTip')}`;
                }
              }
            });
          }
        });
        
        this.excelData2.forEach((jitem, jindex) => {
          const key = `${jitem.order_id}-${jitem.sku}-${jitem.batchNo}-${jitem.outOrderNo}`;
          // if(/[^a-zA-Z0-9_#\[\]\(\)\-]/g.test(String(jitem.sku).trim())){
          //   bstop = false;
          //   errorMsg = this.$t('inputPlusText');
          // }
          if(/[^a-zA-Z0-9_#\[\]\(\)\-]/g.test(String(jitem.order_id).trim())){
            bstop = false;
            errorMsg = this.$t('inputPlusText');
          }
          if (duplicates.has(key)) {
              newArr2.push(jitem);
          } else {
              duplicates.set(key, true);
          }
          if(!this.isableShipping.some(item => item == jitem['shipping_method'])){
            bstop = false;
            errorMsg = `${this.$t('ShippingError')}`;
          }
        })
        if(newArr2.length > 0) {
          bstop = false;
          errorMsg = `${newArr2[0].sku} ${this.$t('dataDuplication')}`;
        }

        if (!bstop) return this.$message.warning(errorMsg);
        thirdApi.checkImportFile(newArr).then(res => {
          if (!res.failed) {
            commonApi.autoImport({
              prefix: 'third-adapter',
              excel: this.file,
              templateCode: this.form.code,
            }).then(() => {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.hide();
              setTimeout(() => {
                this.$emit('submit');
              }, 1000);
            });
          }
        });
      });
    },
    onChange(v, data) {
      this.templateName = data?.label;
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
